/* istanbul ignore file */
/* eslint-disable */
import { useEffect } from 'react';
 
type IntercomBootProps = {

  intercomAppId: string;

  intercomJwt: string;

  intercomBrandId: string;

  verticalPadding?: number;

  horizontalPadding?: number;

};
 
declare global {

  interface Window {

    Intercom?: (...args: any[]) => void;

    intercomSettings?: Record<string, any>;

  }

}

export default function IntercomBoot({

  intercomAppId,

  intercomJwt,

  intercomBrandId,

  verticalPadding,

  horizontalPadding,

}: IntercomBootProps) {

  useEffect(() => {

    window.intercomSettings = {
      api_base: 'https://api-iam.eu.intercom.io',
      app_id: intercomAppId,
      intercom_user_jwt: intercomJwt,

      intercomBrandId,

      ...(verticalPadding !== undefined && {
        vertical_padding: verticalPadding,

      }),

      ...(horizontalPadding !== undefined && {
        horizontal_padding: horizontalPadding,

      }),

    };
 
    if (typeof window.Intercom === 'function') {

      window.Intercom('reattach_activator');

      window.Intercom('update', window.intercomSettings);

      return;

    }
 
    const w = window;

    const d = document;
 
    const intercomStub = function (...args: any[]) {

      (intercomStub as any).q.push(args);

    } as any;
 
    intercomStub.q = [];
 
    w.Intercom = intercomStub;
    const loadIntercom = () => {

      if (document.getElementById('intercom-widget-script')) return;
 
      const s = d.createElement('script');

      s.id = 'intercom-widget-script';

      s.type = 'text/javascript';

      s.async = true;

      s.src = `https://widget.intercom.io/widget/${intercomAppId}`;
 
      const x = d.getElementsByTagName('script')[0];

      if (x?.parentNode) {

        x.parentNode.insertBefore(s, x);

      } else {

        d.head.appendChild(s);

      }

    };
 
    if (document.readyState === 'complete') {

      loadIntercom();

    } else {

      window.addEventListener('load', loadIntercom, false);

    }
 
    return () => {

      window.removeEventListener('load', loadIntercom, false);

    };

  }, [

    intercomAppId,

    intercomJwt,

    intercomBrandId,

    verticalPadding,

    horizontalPadding,

  ]);
 
  useEffect(() => {

    if (!window.Intercom || !intercomJwt) return;
 
    window.Intercom('boot', {
      api_base: 'https://api-iam.eu.intercom.io',
      app_id: intercomAppId,
      intercom_user_jwt: intercomJwt,

      intercomBrandId,

      ...(verticalPadding !== undefined && {
        vertical_padding: verticalPadding,

      }),

      ...(horizontalPadding !== undefined && {
        horizontal_padding: horizontalPadding,

      }),

    });
 
    return () => {

      if (typeof window.Intercom === 'function') {

        window.Intercom('shutdown');

      }

    };

  }, [

    intercomAppId,

    intercomJwt,

    intercomBrandId,

    verticalPadding,

    horizontalPadding,

  ]);
 
  return null;

}